import React, { Component } from 'react';
import { Header, Visibility, Grid } from 'semantic-ui-react';
import ScrollableAnchor from 'react-scrollable-anchor';

import HeaderNav from './components/HeaderNav';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import Contact from './components/Contact';
import Footer from './components/Footer';
class App extends Component {
  state = {
    headerTop: true,
    active: null
  };
  handleUpdate = (e, { calculations }) => {
    if (calculations.pixelsPassed < 10) {
      if (!this.state.headerTop) this.setState({ headerTop: true });
    } else {
      if (this.state.headerTop) this.setState({ headerTop: false });
    }
  };
  render() {
    return (
      <div className="App">
        <Visibility onUpdate={this.handleUpdate}>
          <HeaderNav
            isHome={true}
            headerTop={this.state.headerTop}
            active={this.state.active}
          />
          <ScrollableAnchor id={'Home'}>
            <div>
              <Visibility
                once={false}
                offset={[60, 100]}
                onTopPassed={() => this.setState({ active: 'Home' })}
                onBottomPassedReverse={() => this.setState({ active: 'Home' })}
              >
                <div style={{ height: '100vh' }} className="home-image">
                  <div style={{ height: '100%' }} className="home-container">
                    <Grid
                      style={{ height: '100%' }}
                      container
                      textAlign="center"
                    >
                      <Grid.Column verticalAlign="middle">
                        <Header
                          as="h1"
                          style={{
                            color: 'white',
                            textShadow: '0 0 10px black'
                          }}
                        >
                          {' '}
                          Offrez à votre entreprise un service de signature
                          éléctronique simple et personnalisable{' '}
                        </Header>
                      </Grid.Column>
                    </Grid>
                  </div>
                </div>
              </Visibility>
            </div>
          </ScrollableAnchor>
          <ScrollableAnchor id={'About'}>
            <div>
              <Visibility
                once={false}
                offset={[60, 100]}
                onTopPassed={() => this.setState({ active: 'About' })}
                onBottomPassedReverse={() => this.setState({ active: 'About' })}
              >
                <div>
                  <AboutSection />
                </div>
              </Visibility>
            </div>
          </ScrollableAnchor>
          <ScrollableAnchor id={'Download'}>
            <div>
              <Visibility
                once={false}
                offset={[60, 100]}
                onTopPassed={() => this.setState({ active: 'Download' })}
                onBottomPassedReverse={() =>
                  this.setState({ active: 'Download' })
                }
              >
                <div>
                  <AppSection />
                </div>
              </Visibility>
            </div>
          </ScrollableAnchor>
          <ScrollableAnchor id={'Contact'}>
            <div>
              <Visibility
                once={false}
                offset={[60, 100]}
                onTopPassed={() => this.setState({ active: 'Contact' })}
                onBottomPassedReverse={() =>
                  this.setState({ active: 'Contact' })
                }
              >
                <div>
                  <Contact />
                </div>
              </Visibility>
            </div>
          </ScrollableAnchor>
          <Footer />
        </Visibility>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Home.js